import VueI18n from 'vue-i18n'
import i18n from '@/commons/translations/i18n'
import { ObjectUtils } from '@/commons/utils/objects'
import { Classifier, TranslationMessages } from '@/commons/types'

export class TranslationUtils {
    static combineTranslations (
        translationObject: VueI18n,
        languages: Array<string>,
        commonTranslations: TranslationMessages,
        domainTranslations?: TranslationMessages | undefined): void {
        for (const language of languages) {
            let commonLanguageTranslation = {}
            let domainLanguageTranslation = {}

            if (language in commonTranslations) {
                commonLanguageTranslation = commonTranslations[language]
            }
            if (domainTranslations && language in domainTranslations) {
                domainLanguageTranslation = domainTranslations[language]
            }
            if (ObjectUtils.isEmpty(commonLanguageTranslation) && ObjectUtils.isEmpty(domainLanguageTranslation)) {
                continue
            }
            translationObject.setLocaleMessage(language, {
                ...commonLanguageTranslation,
                ...domainLanguageTranslation
            })
        }
    }

    static translateClassifier (classifier: Classifier): string {
        if (classifier.translationKey && i18n.te(classifier.translationKey)) {
            return i18n.t(classifier.translationKey) as string
        }
        return classifier.label
    }

    static mapRequestErrorTranslationKey (translationKeys: string[], translationGroup: string): string {
        let selectedRemappedTranslationKey
        for (let translationKey of translationKeys) {
            if (translationKey.startsWith('error.')) {
                translationKey = translationKey.replace('error.', '')
            }
            const remappedTranslationKey = `errors.${translationGroup}.${translationKey}`
            if (i18n.te(remappedTranslationKey)) {
                selectedRemappedTranslationKey = remappedTranslationKey
                break
            }
        }

        if (!selectedRemappedTranslationKey) {
            throw Error(`Translation keys does not exist ${translationKeys}`)
        }
        return selectedRemappedTranslationKey
    }

    static translateNotFound (translationKey: string): string {
        if (translationKey && i18n.te(translationKey)) {
            return i18n.t(translationKey) as string
        }
        return 'Sellist valikut ei eksisteeri'
    }
}
